// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> dolben-rise -> traders-row
// Generated: 2026-11-03T15:48:02.877Z
// Counts: 0 design, 61 content, 10 slot group, 2 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Transform your lifestyle at Traders Row, where smart style meets a savvy sense of what's new and next in <a class=\"richtext-link\" href=\"/neighborhood\">Salem</a> living. Trade in hustle for haven with a home base that offers more of what matters, steps from convenient shopping and the iconic Salem Woods. Featuring one and two bedroom apartments for rent in Salem, MA, residents enjoy open floor plans and designer finishes. The <a class=\"richtext-link\" href=\"/amenities\">amenity</a> spaces include a resort style pool, state-of-the-art fitness center, and ample work from home spaces.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Spaces and features designed for everyday living</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "betterbot-chatbot.embed_script": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_betterbot_script"
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "communityfilmembed.video": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/property/6737460151193209/01a1210f-00af-7083-b722-80ca9059b1af.m4v",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reach our leasing team — we're happy to help</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Let's Talk</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.opt_in_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "By submitting this form and signing up for texts, you consent to receive text messages (including review requests and/or surveys) about your experience at the phone number you provided. Message & data rates may apply. Message frequency varies. Unsubscribe at any time by replying STOP. Reply HELP for help.",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.opt_in_enabled": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.opt_in_required": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "contactinfocards.call_label": {
    "overrideType": "VALUE",
    "customValue": "<h3>CALL US</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactinfocards.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h3>OFFICE HOURS</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactinfocards.visit_label": {
    "overrideType": "VALUE",
    "customValue": "<h3>VISIT US</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find a layout that fits your life</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>A look inside our apartments and community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Luxury Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Now Leasing</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "lifestyleintro.headline": {
    "overrideType": "VALUE",
    "customValue": "<h3>A LIFESTYLE DESIGNED FOR YOU</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover local favorites just around the corner</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhooddiscover.headline": {
    "overrideType": "VALUE",
    "customValue": "<h3>DISCOVER THE NEIGHBORHOOD</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.form.opt_in_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "By submitting this form and signing up for texts, you consent to receive text messages (including review requests and/or surveys) about your experience at the phone number you provided. Message & data rates may apply. Message frequency varies. Unsubscribe at any time by replying STOP. Reply HELP for help.",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.form.opt_in_enabled": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.form.opt_in_required": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience The Dolben Difference</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Experience <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<p>What People Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "terms-and-conditions-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Terms &amp; Conditions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore our homes from anywhere</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tours</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We keep it real at the Row. Take a morning loop around <a class=\"richtext-link\" href=\"/neighborhood\">Salem</a> Woods, enjoy a good read by the pool, or sweat it out in the gym - there's nothing stopping you from living your best life!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "applyctabanner.headline": {
    "overrideType": "VALUE",
    "customValue": "<p>APARTMENT HOMES - AVAILABLE NOW</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "incomerestrictedcontent.eligibility_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Traders Row sets aside a number of one- and two-bedroom apartments as income-restricted homes. Eligibility depends on your household size and your household's total gross annual income. Income limits and rents are updated from time to time, so please <a href=\"/contact-us\">contact our leasing office</a> for the current figures. Housing Choice Voucher holders are welcome to apply, and minimum income requirements do not apply to households applying with a voucher.</p>",
    "mappedField": null
  },
  "incomerestrictedcontent.important_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Accessible and adaptable one- and two-bedroom homes are part of the income-restricted program. Please ask us about available accessibility features or any reasonable accommodations you may need.</p><p>Residents are responsible for utilities not included in rent, such as electric and water/sewer, as well as phone, cable, and internet services, as applicable to the home.</p>",
    "mappedField": null
  },
  "incomerestrictedcontent.utilities_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Traders Row, electric and water/sewer are billed separately based on usage. Where your program requires it, a utility allowance for these services is factored into your income-restricted rent calculation. Please ask our office how this applies to your apartment.</p>",
    "mappedField": null
  },
  "lifestyleintro.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">We keep it real at the Row. Take a morning loop around </span><a class=\"richtext-link\" href=\"/neighborhood\">Salem</a><span style=\"font-size: 16px;\"> Woods, enjoy a good read by the pool, or sweat it out in the gym - there's nothing stopping you from living your best life!</span></p>",
    "generatedValue": "<p>Your <a href=\"/amenities\">apartment-living experience</a> comes first at Traders Row. Every one- and two-bedroom home in Salem has a designer kitchen with granite counters and stainless steel appliances, plus plank flooring, central air, and your own washer and dryer. Need to focus? Traders Works, our co-working space, is ready for your next call. When you're done for the day, grab a coffee in the resident cafe, swim in the resort-style pool, or meet friends by the fire pits and gas grills under the pergola. Packages go to the Amazon Hub, and pets can play at the Bark Park. At Traders Row, everything you need is right at home.</p>",
    "mappedField": null
  },
  "neighborhooddiscover.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": "<p>Traders Row sits next to Salem Woods, so you have 160 acres of green space and nature trails just outside your door. Gallows Hill Park and Forest River Park are close by too. Downtown Salem and the MBTA Commuter Rail are easy to reach, along with local favorites like Turners Seafood at Lyceum Hall, Bambolina, and Jaho Coffee Roaster &amp; Wine Bar. For everyday errands, Market Basket and Whole Foods at Swampscott are a quick drive away. Want to see what else is near you in Salem? Take a look around on our <a href=\"/interactive-map\">interactive map</a>.</p>",
    "mappedField": "property_home_neighborhood_blurb"
  },
  "retailshops.intro": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Shopping &amp; Dining Near Traders Row</p>",
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Nothing helps you to imagine the possibilities for a <a class=\"richtext-link\" href=\"/floor-plans\">new apartment home</a> quite like a virtual tour. Take a look around our new apartments in Salem, MA - we know you'll love it here!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactinfocards.address": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_google_place_url"
      }
    }
  },
  "footer.address": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_google_place_url"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Schedule Tour"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Search Apartments"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/01a10ce2-bfcc-7149-85f4-4e63676214ff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Comfortable seating area in the community lounge with plush chairs and a coffee table."
      }
    }
  },
  "incomerestrictedcontent.tier_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "bedroom": {
        "type": "GENERATOR",
        "generatedValue": "One-Bedroom Rent"
      },
      "rent": {
        "type": "GENERATOR",
        "generatedValue": "$2,466 per month"
      },
      "households": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>1-Person Household: $88,776 – $96,000</li><li>2-Person Household: $88,776 – $110,000</li></ul>"
      }
    }
  },
  "incomerestrictedcontent.tier_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "bedroom": {
        "type": "GENERATOR",
        "generatedValue": "Two-Bedroom Rent"
      },
      "rent": {
        "type": "GENERATOR",
        "generatedValue": "$2,715 per month"
      },
      "households": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>2-Person Household: $97,740 – $110,000</li><li>3-Person Household: $97,740 – $123,000</li><li>4-Person Household: $97,740 – $137,000</li></ul>"
      }
    }
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "galleryslider.images": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "floorplanslist.apartment_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_31ccc58c-e9b4-454c-999e-05be1999a4ac",
      "custom_37636240-dff9-47ff-9bb6-ffc15926356f",
      "custom_52e45e3a-3201-41c1-bda6-fbeba7d2cafb",
      "custom_0af8006b-1a72-4424-8186-f5ae3e12e8de",
      "custom_32aa2c6c-abef-42b7-9180-609785b44c2a",
      "custom_0d26e78c-2e9d-4378-ac06-49217fcea015",
      "custom_3bff1a54-563e-4c94-b6e6-b79e61352f5a",
      "custom_81ec6f26-cd67-4c2e-a7f3-2db14970e77f",
      "custom_8b0bdb8f-ba85-4060-abad-212a26498c63",
      "custom_39e3ff2e-4f81-46a2-8639-99b152369c07",
      "custom_1c35413e-d09c-480f-b2ee-32805c6a8809",
      "custom_2c0cd1fb-ce7c-4fe8-8961-a9172c2e36d3",
      "custom_41a67972-9993-474a-89e7-372a2961c591"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "betterbot-chatbot",
      "blockId": "betterbot-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
